import { render, staticRenderFns } from "./Mul25x25.vue?vue&type=template&id=22c8fd9a&scoped=true&"
import script from "./Mul25x25.vue?vue&type=script&lang=js&"
export * from "./Mul25x25.vue?vue&type=script&lang=js&"
import style0 from "./Mul25x25.vue?vue&type=style&index=0&id=22c8fd9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8fd9a",
  null
  
)

export default component.exports